import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class InvoiceService
    extends BaseService {

    static async upload(bookingID, uploadGUID, travelExpensesValue) {
        return BaseService.callAPI('invoice/upload', { bookingID, uploadGUID, travelExpensesValue });
    }

    static async notifyValueIncorrect(id, reason) {
        return BaseService.callAPI('booking/notify-value-incorrect/' + id, { reason });
    }

    static async unsubmit(id) {
        return BaseService.callAPI('invoice/unsubmit/' + id);
    }

    static async markAsPaid(ids) {
        return BaseService.callAPI('invoice/mark-as-paid', { ids });
    }

    static async save(invoice, booking) {
        return BaseService.callAPI('invoice/save', {
            invoice, booking
        });
    }

    static async getForBooking(id) {
        return BaseService.callAPI('invoice/get-for-booking/' + id);
    }

    static async submitMissingBooking(missingBooking) {
        return BaseService.callAPI('invoice/submit-missing-booking', missingBooking);
    }

    static async markPaidByVendor(bookingIDs) {
        return BaseService.callAPI('invoice/mark-paid-by-vendor', bookingIDs);
    }

    static async archive(id) {
        return BaseService.callAPI('invoice/archive/' + id);
    }

}
